var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"label":_vm.label,"placeholder":"Введите название","persistent-hint":"","hide-no-data":"","item-text":"name","item-value":"id","small-chips":_vm.multiple,"multiple":_vm.multiple,"return-object":_vm.returnObject,"loading":_vm.loading,"items":_vm.items}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }